<span [class]="compact
                 ? 'inline-flex items-center gap-0.5 overflow-hidden rounded-full px-1.5 py-px text-xs leading-normal text-white whitespace-nowrap'
                 : 'inline-flex items-center gap-0.5 overflow-hidden rounded-full px-1.5 py-px text-xs leading-normal text-white whitespace-nowrap'"
      [style.background-color]="tag.color || '#687582'"
      [attr.title]="tag.name">
  <span class="flex shrink-0 self-center leading-none">
    <app-icon [class]="compact
                         ? 'inline-flex !h-3 !w-3 !min-w-3 !text-[12px] !leading-3'
                         : 'inline-flex !h-3 !w-3 !min-w-3 !text-[12px] !leading-3'"
              [isFlexBox]="false">{{ icon }}</app-icon>
  </span>
  {{ displayName }}
</span>
